import React, { useState,useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components} from "react-select";
import { toast } from 'react-toastify';
import axios from 'axios';

const AssignVehicle = ({ show, onClose, data, refresh }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [staffoption, setstaffopt] = useState([]);
    const [staff, setstaff] = useState(null);
    const [selstaff, setSelstaff] = useState(null);
    useEffect (() => {
        axios.get(`${baseURL}/dropdown/get_staffs`, {params: {branch_id}})
        .then(response => {
            const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.employee_name,
            }));
            setstaffopt(formattedsource);
        })
        .catch(error => {
            console.log(error);
        });
    }, []);


    useEffect (() => {
        if(data.assigned_staff_id && staffoption){
            setstaff(data.assigned_staff_id);
            setSelstaff(staffoption.find(opt => opt.value === data.assigned_staff_id));
        }
    }, [data, staffoption]);


    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};


        if(!staff){
            newErrors.staff = 'This Field is Required.';
        }


        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        let postData = {  staff_id: staff, user_id: user_id };
        
        
        // Send the request to the backend
        axios.put(`${baseURL}/manage_vehicle/assign_staff/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Staff Assigned Successfully!");
            })
            .catch(error => {
                console.log("Error:", error);
                toast.error("Staff Assignment Failed");
            });
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Assign Delivery Staff</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w500 fs-7'>Vehicle Category / Brand</label>
                            <label className='text-primary fs-3 font-w500'>{data.category_name ? data.category_name : '-'} / {data.vehicle_brand ? data.vehicle_brand : '-'}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w500 fs-7'>Vehicle Number</label>
                            <label className='text-primary fs-3 font-w500'>{data.vehicle_number}</label>
                        </div>

                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select  placeholder="Select Staff"
                                options={staffoption}
                                value={selstaff}
                                onChange={(e)=> {
                                    setstaff(e.value);
                                    setSelstaff(e);
                                }}
                                styles={customStyles}
                            
                            />
                            {errors.staff && <small className="text-danger">{errors.staff}</small>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Assign Staff <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AssignVehicle;
